
import { axeptaUser } from '../config/axepta-config.js';
import { baseURL,cloudRunBaseURL, appURL } from '../config/api-config.js';

export  function prepAdresse(ref,id,prix,user) {

    //console.log("prepa adresse");
    const CryptoJS = require("crypto-js");
    const Blowfish = require('blowfish-node');
    

    let urlAxepta = "";
    
    let hmacPassword = axeptaUser.hmacPassword;
    let merchantId = axeptaUser.merchantID;
    let refCOntrat=ref;
    let transId=id;
    let amount = prix*100;
    let prixAffiche = Math.round(+amount/100);
    let currency = "EUR";
    let urlSuccess = appURL+"/order/success/"+ref+"/"+id;
    let urlFailure = appURL+"/order/fail/"+ref;
    let urlNotify = cloudRunBaseURL + "paiement/check";
    let orderDesc = "contrat "+id+"-"+user.prenom+"-"+user.nom;
    //let orderDesc = "Test:0000";
    let userData = user.prenom+"_"+user.nom;
    let capture = "encrypt";
    let response = "AUTO";

    let jsonCustomer={
        "consumer": {
            "firstName": user.prenom,
            "lastName": user.nom
        },
        "mobilePhone": {
            "subscriberNumber" : user.tel
        },
        "email": user.email
    };

    
    let pBillToCustomer=JSON.stringify(jsonCustomer);
    pBillToCustomer=btoa(pBillToCustomer);


    let pMerchantID="MerchantID="+merchantId;
    let pMsgVer="MsgVer=2.0";
    let pTransID = "TransID="+transId;
    let pRefNr="RefNr="+id;
    let pAmount = "Amount="+amount;
    let pCurrency = "Currency="+currency;
    let pURLSuccess = "URLSuccess="+urlSuccess;
    let pURLFailure = "URLFailure="+urlFailure;
    let pURLNotify = "URLNotify="+urlNotify;
    let pOrderDesc = "OrderDesc="+orderDesc;
    let pUserData = "UserData="+userData;
    let pCapture = "Capture="+capture;
    let pResponse = "Response="+response;

     //Creating MAC value
     let mac = CryptoJS.HmacSHA256(`*${transId}*${merchantId}*${amount}*${currency}`, hmacPassword);
    
    let pMAC = "MAC="+mac;
    //console.log(mac, pMAC);

    let query = [pMerchantID, pMsgVer, pTransID, pRefNr, pAmount, pCurrency, pURLSuccess, pURLFailure, pURLNotify, pOrderDesc, pUserData, pBillToCustomer/* , pCapture , pResponse*/, pMAC];
    
    // building the string MerchantID, Len and Data (encrypted)
    let plaintext = query.join("&");
   
    //console.log(plaintext);

    let len = plaintext.length;

    
    const bf = new Blowfish(axeptaUser.blowfishPassword, Blowfish.MODE.ECB, Blowfish.PADDING.NULL); // only key isn't optional

    const encoded = bf.encode(plaintext);
    //convert to hexa 2/2
    const data = Array.from(encoded).map((b) => b.toString(16).padStart(2, "0")).join(""); 


    urlAxepta = "https://paymentpage.axepta.bnpparibas/payssl.aspx?MerchantID="+merchantId+"&Len="+len+"&Data="+data+"&CustomField1="+prixAffiche+",00 Euros"+"&CustomField2="+ref+"&CustomField4="+prixAffiche+",00 Euros"+"&CustomField5="+userData;
    
    console.log(urlAxepta);
    return urlAxepta;
}